(function ($, Promise) {

    // Constructor
    function VICCTryAnotherAddress() {
      // console.log("VICCTryAnotherAddress: constructor()");

      this.initialMapPosition = {};
      this.overlayMap = false;
      this.api = new VICCCloudAPI();

      this.disableScrollTimeout = false;
    }

    /*
     * Triggered by Barba on page change
     */
    VICCTryAnotherAddress.prototype.attach = function (dom) {
      // console.log("VICCTryAnotherAddress: attach()");

      // Init Triggers
      this.initTrigger();
    }

    VICCTryAnotherAddress.prototype.initMap = function () {
      if (this.overlayMap == false) {
        // Create maps
        this.overlayMap = new VICCMap(document.getElementById("overlay-map-wrapper"));

        // Init maps
        if (app.googleMapReady) {
          this.overlayMap.initMap(this.initialMapPosition);
        }
      }
    }


    VICCTryAnotherAddress.prototype.setPosition = function (zoom, center, markerPosition) {
      if (this.overlayMap != false) {

        if (zoom) {
          this.overlayMap.map.setZoom(zoom);
        }
        if (center) {
          this.overlayMap.map.setCenter(center);
        }
        if (markerPosition) {
          this.overlayMap.marker.setPosition(markerPosition);
          this.overlayMap.marker.setVisible(true);
        }

      } else {

        if (zoom) {
          this.initialMapPosition.zoom = zoom;
        }
        if (center) {
          this.initialMapPosition.center = center;
        }
        if (markerPosition) {
          this.initialMapPosition.markerPosition = markerPosition;
        }

      }
    }

    /*
     * Init click events
     */
    VICCTryAnotherAddress.prototype.initTrigger = function () {
      // $(this.mainMap).on("selectAddress", $.proxy(function () {
      //   this.selectAddress();
      // }, this));

      $("#overlay-map-wrapper").on("click", ".cta-button", $.proxy(function (e) {
        e.preventDefault();
        this.processAnotherAddress();
      }, this));

      $("#overlay-map-wrapper").on("click", ".close-overlay", $.proxy(function (e) {
        e.preventDefault();
        this.hideOverlay();
      }, this));

    }

    /*
     * Called by the Google Map API when it is ready to be used.
     */
    VICCTryAnotherAddress.prototype.googleMapReady = function () {
      // console.log("VICCTryAnotherAddress: googleMapReady()");
      if (this.overlayMap) {
        this.overlayMap.initMap(this.initialMapPosition);
      }
    }

    /*
     * Shows the Try Another Address map overlay
     */
    VICCTryAnotherAddress.prototype.showOverlay = function () {

      // Init Google map. This has been moved out the attach() ufnction to deuce google maps fees
      this.initMap(this.initialMapPosition);

      $("#overlay-map-wrapper .overlay-top-bar-inner > div:not(.hidden)").addClass("hidden");
      $("#overlay-map-wrapper .overlay-top-bar-inner .address").removeClass("hidden");

      if (this.disableScrollTimeout) {
        clearTimeout(this.disableScrollTimeout);
      }

      this.disableScrollTimeout = setTimeout(function () {
        // Disable scroll on body
        $("body").addClass("disable-scroll");
      }, 400);

      // Show overlay map
      $("#overlay-map-wrapper, #overlay-map-wrapper .close-overlay").removeClass("hidden");
    }

    /*
     * Hide the Try Another Address map overlay
     */
    VICCTryAnotherAddress.prototype.hideOverlay = function () {

      // Allow scroll on body
      $("body").removeClass("disable-scroll");

      // Scroll to current visualization
      window.scrollTo(0, $("#visualize-result-container").offset().top - ($("#header").outerHeight() - 1));

      // Hide overlay map
      $("#overlay-map-wrapper, #overlay-visualize-process").addClass("hidden");

      $("#overlay-map-wrapper .overlay-top-bar-inner > div:not(:first-child)").addClass("hidden");
      $("#overlay-map-wrapper .overlay-top-bar-inner > div:first-child").removeClass("hidden");
    }

    /*
     * Request the process of another address and
     */
    VICCTryAnotherAddress.prototype.processAnotherAddress = function () {

      $("#overlay-map-wrapper .overlay-top-bar-inner > div:not(.hidden)").addClass("hidden");
      $("#overlay-map-wrapper .overlay-top-bar-inner .loading").removeClass("hidden");

      // Hide Map CTA
      if (window.viewport().width <= this.overlayMap.responsiveBreakpoint) {
        gsap.to("#overlay-map-cta-wrapper", 0.5, {
          height: 0,
        });
      }

      // Show process
      $("#overlay-visualize-process").removeClass("hidden");

      // Start process animation timeline
      $.each(Object.keys(app.components.anim.processStepTimelines), $.proxy(function (index, el) {
        if ((typeof app.currentComponent.selectedDisaster != "undefined") && (el == app.currentComponent.selectedDisaster)) {
          app.components.anim.processStepTimelines[app.currentComponent.selectedDisaster].restart().play();
        } else {
          app.components.anim.processStepTimelines[el].pause().restart();
        }
      }, this));

      Promise.all([
        this.api.requestVisualization(this.overlayMap.lat, this.overlayMap.lng),
        new Promise(resolve => setTimeout(resolve, 1500)),
      ]).then($.proxy(function (data) {

        $(this).trigger("visualizationReady", data[0]);

        // Show completion
        $("#overlay-map-wrapper .overlay-top-bar-inner > div:not(.hidden)").addClass("hidden");
        $("#overlay-map-wrapper .overlay-top-bar-inner .completed").removeClass("hidden");

        // Update Breadcrumb thumbnail
        $("#breadcrumb-item-preview").css("background", "url(" + this.overlayMap.originalUrl + ") no-repeat center center");
        $("#breadcrumb-item-preview").css("background-size", "cover");

        // Make sure that the WHAT NOW button is shown on share page
        $("#visualize-result-share").removeClass("hidden");

        // Hide overlay
        setTimeout($.proxy(function () {
          this.hideOverlay()

          // Reset/Stop process timeline
          $.each(Object.keys(app.components.anim.processStepTimelines), $.proxy(function (index, el) {
            app.components.anim.processStepTimelines[el].pause().restart();
          }, this));
        }, this), 1500);

      }, this));

    }


    VICCTryAnotherAddress.prototype.dettach = function () {
      // console.log("VICCTryAnotherAddress: dettach()");
      if (this.overlayMap) {
        this.overlayMap.destroy();
      }
    }

    // Expose VICCTryAnotherAddress
    window.VICCTryAnotherAddress = VICCTryAnotherAddress;

  }
)
(jQuery, Promise);
